/**
 * @brisa/ui · lib/utils
 *
 * Helpers compartilhados pelo Design System Facelift v1 (per ADR §D6, §"Armadilha shadcn #7").
 *
 * `cn()` combina `clsx` (truthy-aware class joining) com `tailwind-merge`
 * (resolução de conflitos de classes Tailwind) — convenção canônica do
 * shadcn/ui. Primitivos shadcn em `components/ui/*` importam `cn` daqui.
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
